export default __webpack_public_path__ + "01756313f2d2ffb6ade6dd4010d9a276.svg";